import React, {useEffect, useState} from 'react';
import { createLogger } from '../utils/logging';

const logger = createLogger('ClaimsWebcomponent');

export const Claims = (props: any) => {
    logger.debug('Component Initialized', 'Claims webcomponent mounted', { props });
    const {context} = props;
    const ref = React.useRef(null);
    const [viewName, setViewName] = useState<string>('claimsSearch');
    const [claimContext, setClaimContext] = React.useState(() => JSON.stringify(context));

    // Lazy load the web component script
    useEffect(() => {
        if (!customElements.get('claims-micro-product')) {
            const env = (window as any).environments;
            if (env?.claimsWebComponentURL) {
                const script = document.createElement('script');
                script.src = env.claimsWebComponentURL;
                script.onerror = () => logger.error('Script Load Failed', 'Unable to load claims webcomponent', { url: env.claimsWebComponentURL });
                document.head.appendChild(script);
            }
        }
    }, []);

    useEffect(() => {
        const handleEvent = (e: any) => {
            logger.debug('Event Received', 'Claims webcomponent event', { type: e.detail?.type });
            const {detail} = e;

            // eslint-disable-next-line default-case
            switch (detail.type) {
                case '[CLAIMS] ROUTE': {
                    logger.info('Route Change', 'Claims view navigation', {
                        viewName: detail.payload.viewName,
                        searchDetailParam: detail.payload.searchDetailParam,
                    });
                    const newContext = JSON.stringify({...context, searchDetailParam: detail.payload.searchDetailParam});
                    setClaimContext(newContext);
                    if (detail.payload.viewName) {
                        setViewName(detail.payload.viewName);
                    }
                    break;
                }
            }
        };

        const curentRef: any = ref.current;
        logger.debug('Effect Setup', 'Attaching event listener', { hasRef: !!curentRef });
        setClaimContext(JSON.stringify(context));

        if(curentRef) {
            curentRef.addEventListener('event', handleEvent);
        }
        return () => {
            curentRef.removeEventListener('event', handleEvent);
        };
    }, [context]);

    return (
        // @ts-ignore
        <claims-micro-product ref={ref}  view={viewName}  id="claims-webcomponent" data-testid="claims-micro-product" text="Claims" context={claimContext}/>
    );
};

export default Claims;
